import i18next from 'i18next';

// Commons
import {
  GENERIC_MODAL_CANCEL_BUTTON,
  GENERIC_MODAL_CONFIRM_BUTTON,
  GENERIC_MODAL_DOWNLOAD_BUTTON,
  GENERIC_MODAL_SAVE_BUTTON,
} from '@commons/Modals/GenericModal/genericModalActions';
import { getConfirmationModal } from '@commons/Modals/ConfirmationModal';

import ProductForecastTemplateModal from '@src/routes/forecast/Forecast/SalesPlanning/utils/ProductForecastTemplateModal';

export const getResetWarningModalParams = ({ handleReset, productName, formattedDate }) =>
  getConfirmationModal({
    type: 'warning',
    title: i18next.t('FORECAST.POS_PRODUCTION_PLANNING.RESET_WARNING_MODAL_TITLE'),
    icon: '/images/inpulse/refresh-white-small.svg',
    content: i18next.t('FORECAST.POS_PRODUCTION_PLANNING.RESET_WARNING_MODAL_CONTENT', {
      productName,
      date: formattedDate,
    }),
    actions: [
      GENERIC_MODAL_CANCEL_BUTTON(),
      {
        ...GENERIC_MODAL_CONFIRM_BUTTON(),
        handleClick: handleReset,
      },
    ],
  });

export const getOverwriteProductionEntriesWarningModalParams = ({
  productName,
  formattedDate,
  handleOverwrite,
  handleCancelOverwrite,
}) =>
  getConfirmationModal({
    type: 'warning',
    title: i18next.t(
      'FORECAST.POS_PRODUCTION_PLANNING.OVERWRITE_PRODUCTION_ENTRIES_WARNING_MODAL_TITLE',
    ),
    icon: '/images/inpulse/pen-white-small.svg',
    content: i18next.t(
      'FORECAST.POS_PRODUCTION_PLANNING.OVERWRITE_PRODUCTION_ENTRIES_WARNING_MODAL_CONTENT',
      {
        productName,
        date: formattedDate,
      },
    ),
    actions: [
      {
        ...GENERIC_MODAL_CANCEL_BUTTON(),
        handleClick: () => {
          handleCancelOverwrite();
        },
      },
      {
        ...GENERIC_MODAL_SAVE_BUTTON(),
        handleClick: () => {
          handleOverwrite();
        },
      },
    ],
    preventClosing: true,
  });

export const getProductForecastTemplateModalConfig = (
  data,
  handleProductForecastTemplateDownload,
  handleCloseCleanUp,
) => ({
  type: 'action',
  width: '588px',
  height: '540px',
  icon: '/images/inpulse/file-download-black-small.svg',
  title: i18next.t('FORECAST.SALES_PLANNING.PRODUCT_FORECAST_TEMPLATE_FILE_DOWNLOAD'),
  component: ProductForecastTemplateModal,
  data,
  handleCloseCleanUp,
  actions: [
    GENERIC_MODAL_CANCEL_BUTTON(),
    {
      ...GENERIC_MODAL_DOWNLOAD_BUTTON(),
      handleClick: handleProductForecastTemplateDownload,
    },
  ],
});
